/**
 * One collapsed row of the case file: a label, the line that says what is
 * inside, and a right-hand meta. The attempt, the plan and the Record all fold
 * this way, so below the stop card the page reads as a short contents list a
 * person opens one row of at a time.
 *
 * Native `<details>`: the browser already knows the gesture, and a closed row
 * keeps its body out of find-in-page until it is opened.
 */
import type { ReactNode } from "react";

export function CaseFold({
  label,
  summary,
  meta,
  defaultOpen = false,
  testId,
  className,
  children,
}: {
  label: string;
  /** What is inside, in one line. Empty prints nothing. */
  summary?: ReactNode;
  /** The right-hand fact (an attempt and its clock, a revision and its author). */
  meta?: ReactNode;
  defaultOpen?: boolean;
  testId?: string;
  className?: string;
  children: ReactNode;
}) {
  return (
    <details
      className={"cf-section cf-fold" + (className ? ` ${className}` : "")}
      data-testid={testId}
      open={defaultOpen}
    >
      <summary className="cf-fold-head">
        <span className="cf-fold-chev" aria-hidden />
        <span className="cf-fold-label">{label}</span>
        {summary ? <span className="cf-fold-sum">{summary}</span> : null}
        {meta ? <span className="cf-fold-meta">{meta}</span> : null}
      </summary>
      <div className="cf-fold-body">{children}</div>
    </details>
  );
}
